module.exports = __webpack_public_path__ + "img/chat-active.d48e2ef2.svg";